import watchGetArticleRequested from './getArticleSaga';

export default [
  watchGetArticleRequested(),
];
